/* src/app/app.component.scss */
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Regular.ttf") format("truetype");
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-RegularItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: 500;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-Bold.ttf") format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "Neue Simon Kucher";
  src: url("./media/NeueSimonKucher-BoldItalic.ttf") format("truetype");
  font-style: italic;
  font-weight: bold;
}
.container-box {
  background: #fff;
}
.filter-container {
  position: relative;
  padding: 0;
  min-height: 10.5rem;
}
.box-container {
  overflow: hidden;
  position: relative;
  margin-right: 0.5rem;
  padding: 0;
  min-height: 10.5rem;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #FFF;
}
.box-container .box-header {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 1rem;
  color: var(--secondary);
}
.box-container .box-header.h6 {
  font-size: 1rem;
  margin-top: 1.2rem;
}
.box-container .box-body {
  padding: 0.1rem 0.8rem;
}
.collapse-filters {
  position: absolute;
  z-index: 100;
  width: 100.5%;
  margin-left: -1.3rem;
  padding-left: 1.6rem;
  background: #fff;
  border-left: 5px solid rgb(109, 110, 106);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
}
::ng-deep .ant-select {
  margin-top: 0;
}
::ng-deep .nz-checkbox-wrapper label {
  top: 0.2rem !important;
}
.page-content {
  padding-left: 3vw;
  width: 100%;
}
.body-container {
  padding-top: 1.5rem;
}
/*# sourceMappingURL=app.component.css.map */
